import * as React from "react";
import PropTypes from "prop-types";

import Button from "./Button";

import * as userUtils from "../modules/user/utils";

import * as styles from "../styles/components/EmailAndPasswordForm.css";

export default class ForgotPasswordForm extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            email: ""
        };
    }

    handleTextChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.email);
    }

    render() {
        const isSubmitEnabled = userUtils.isValidEmail(this.state.email);

        return (
            <form className={`${styles.loginForm} ${styles.withShadow}`}>
                <h1 className={styles.formHeader}>Forgot Your Password?</h1>
                <p className={styles.instructions}>
                    These things happen. Now let's fix that.
                </p>

                <div className={`${styles.field} ${styles.email}`}>
                    <input
                        type="text"
                        id="forgot-password-form-email"
                        name="email"
                        placeholder="email@domain.com"
                        aria-label="Email address"
                        value={this.state.email}
                        onChange={this.handleTextChange}
                    />
                </div>

                <Button
                    type="submit"
                    onClick={this.handleSubmit}
                    wrapperClass={styles.login}
                    disabled={!isSubmitEnabled}
                >
                    Send Reset Email
                </Button>
            </form>
        );
    }
}

ForgotPasswordForm.defaultProps = {};

ForgotPasswordForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordForm.js